module.exports = __webpack_public_path__ + "img/add.9fe9703f.svg";